export default {
  notAllowedForRetry({ fullStatus, isAppleVpp }) {
    const UNINSTALL_FAILED_STATUS = 'UNINSTALL_FAILED';

    const invalidStatusesArray = [
      'PENDING',
      'UNINSTALL_PENDING',
      'UPDATE_FAILED',
      'UPDATE_PENDING',
      'UPDATE_SUCCESS',
      'UNINSTALL_SUCCESS',
      'MDM_UNENROLLED',
    ];

    return (
      (fullStatus === UNINSTALL_FAILED_STATUS && !isAppleVpp)
        || invalidStatusesArray.includes(fullStatus)
    );
  },
};
